import React, { useState, useEffect } from 'react';

function Gematria() {
  const [targetGematria, setTargetGematria] = useState('');
  const [matchingWords, setMatchingWords] = useState([]);
  const [wordFrequencies, setWordFrequencies] = useState({});
  const [gematriaMap, setGematriaMap] = useState({});

  useEffect(() => {
    // Function to read and parse the gematria_output.txt file
    const parseGematriaFile = async () => {
      try {
        const response = await fetch('gematria_output.txt'); // Assuming the file is in the same directory
        const text = await response.text();
        const gematriaMap = {};

        text.split('\n').forEach((line) => {
          const [gematria, word] = line.split(' : ');
          const trimmedWord = word.trim();

          if (!gematriaMap[trimmedWord]) {
            gematriaMap[trimmedWord] = [];
          }

          gematriaMap[trimmedWord].push(gematria.trim());
        });

        setGematriaMap(gematriaMap);
      } catch (error) {
        console.error('Error reading gematria_output.txt:', error);
      }
    };

    parseGematriaFile();
  }, []);

  // Function to handle user input change
  const handleTargetGematriaChange = (e) => {
    const value = e.target.value;
    setTargetGematria(value);

    // Find matching words
    const matchingWords = Object.entries(gematriaMap)
      .filter(([word, gematriaList]) => gematriaList.includes(value))
      .map(([word]) => word);

    // Count word frequencies
    const wordCounts = {};
    matchingWords.forEach((word) => {
      const gematriaList = gematriaMap[word];
      wordCounts[word] = gematriaList.filter((gematria) => gematria === value).length;
    });

    setMatchingWords(matchingWords);
    setWordFrequencies(wordCounts);
  };

  return (
    <div>
      <p style={{ color: 'black', fontWeight: 'bold' }}>Enter a number below to see a list of all the words in the Torah with the same Gematria value and the number of times each word is mentioned.:</p>
      <input
        type="number"
        value={targetGematria}
        onChange={handleTargetGematriaChange}
        placeholder="Enter sum..."
      />
      {/* Matching Hebrew words */}
      <div className="matching-words">
        {matchingWords.length > 0 && (
          <div>
            <p>Matching Hebrew words:</p>
            <ul className="matching-words-list">
              {matchingWords.map((word, index) => (
                <li key={index}>
                  <span className="translation">
                    {wordFrequencies[word] > 1 && (
                      <span style={{ color: 'orange' }}>
                        ({wordFrequencies[word]})
                      </span>
                    )}
                  </span>
                  <span className="index">{index + 1}.</span>
                  <span className="word">{word}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default Gematria;
